var _mask, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgQuestion = function SvgQuestion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "maskcxzczxczxcxzczxc2312321",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00008 2.55047C4.99034 2.55047 2.55047 4.99034 2.55047 8.00008C2.55047 11.0098 4.99034 13.4497 8.00008 13.4497C11.0098 13.4497 13.4497 11.0098 13.4497 8.00008C13.4497 4.99034 11.0098 2.55047 8.00008 2.55047ZM1.66675 8.00008C1.66675 4.50228 4.50228 1.66675 8.00008 1.66675C11.4979 1.66675 14.3334 4.50228 14.3334 8.00008C14.3334 11.4979 11.4979 14.3334 8.00008 14.3334C4.50228 14.3334 1.66675 11.4979 1.66675 8.00008Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.17705 5.51265C7.86851 5.45973 7.55119 5.51771 7.2813 5.67633C7.01141 5.83494 6.80637 6.08396 6.70249 6.37927C6.6215 6.60947 6.36924 6.73044 6.13903 6.64946C5.90883 6.56848 5.78786 6.31622 5.86884 6.08601C6.04198 5.59383 6.38372 5.1788 6.83354 4.91444C7.28335 4.65008 7.81221 4.55345 8.32645 4.64165C8.84069 4.72986 9.30712 4.99721 9.64312 5.39636C9.97905 5.79541 10.1629 6.30045 10.1623 6.82206C10.1621 7.64562 9.55027 8.20269 9.08177 8.51502C8.83405 8.68017 8.58947 8.80214 8.40857 8.88254C8.31749 8.92302 8.24097 8.95366 8.18619 8.97453C8.15877 8.98497 8.13668 8.99301 8.12083 8.99865L8.10179 9.00532L8.09595 9.00731L8.09399 9.00798L8.09325 9.00822C8.09325 9.00822 8.09268 9.00841 7.95295 8.58923L8.09268 9.00841C7.86117 9.08558 7.61093 8.96047 7.53376 8.72896C7.45667 8.49767 7.58147 8.2477 7.81254 8.17027L7.81425 8.16968L7.82477 8.166C7.8348 8.16243 7.85069 8.15666 7.87159 8.1487C7.91347 8.13275 7.97504 8.10815 8.04966 8.07499C8.20015 8.0081 8.39743 7.90914 8.59157 7.77972C9.00674 7.50294 9.27853 7.17637 9.27853 6.82179L9.27853 6.82113C9.279 6.50808 9.16866 6.20497 8.96705 5.96548C8.76545 5.72599 8.48559 5.56558 8.17705 5.51265Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55822 10.9458C7.55822 10.7018 7.75605 10.504 8.00008 10.504H8.00597C8.25001 10.504 8.44783 10.7018 8.44783 10.9458C8.44783 11.1899 8.25001 11.3877 8.00597 11.3877H8.00008C7.75605 11.3877 7.55822 11.1899 7.55822 10.9458Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#maskcxzczxczxcxzczxc2312321)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "matrix(-1 0 0 1 16 0)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/question.4ceffd96.svg";
export { ForwardRef as ReactComponent };